export default "__VITE_ASSET__291df933__"